import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { DivisionsService } from '../../../../../../shared/modules/core/services/divisions.service';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-valorant-solo-net-wins',
  templateUrl: './valorant-net-wins.component.html'
})
export class ValorantNetWinsComponent {
  service = 'netwins';
  availableServices = services['valorant'].filter(service => service.service !== this.service);
  serviceParams = {
    game: 'valorant',
    service: 'netwins',
    type: 'solo',
    title: {
      en: 'Net Wins',
    },
    subtitle: {
      en: 'Guaranteed Positive Number of Ranked Wins in Solo or Duo Boosting',
      fr: 'Nombre positif garanti de victoires classées en boosting solo ou duo',
      de: 'Garantierte positive Anzahl von Ranglistensiegen im Solo oder Duo Boosting',
      pt: 'Número positivo garantido de ranked wins em Boosting Solo ou Duo',
      es: 'Número positivo garantizado de Ranked Wins en Solo o Duo Boosting',
    },
    start: DivisionsService.getValueByRank('Silver III', 'valorant'),
    desired: 5,
    serviceName: 'Net Wins',
    min: 1,
    max: 5
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Net Win Boost?",
        answer: "A Net Win boost is the difference between the number of victories and losses. For each loss, you receive an additional win. ex: 2 Net Wins = 2W-0L or 3W-1L."
      },
      {
        question: "What If I Reach A New Rank And Still Have Net Wins Remaining?",
        answer: "In ranks below Diamond we play one division above the initial rank. In Diamond+, net wins are only valid for the purchased division."
      },
      {
        question: "Can I Purchase Net Wins Before My Placements Are Complete?",
        answer: "Only accounts with all placements completed are eligible for Net Wins."
      },
      {
        question: "Can I Play With The Booster In Duo Queue Boosting?",
        answer: "Indeed, you can. To accomplish this, go to the order customization menu and select \"Duo\" before clicking \"Buy Boost Now\"."
      },
      {
        question: "What If My MMR is Higher Than My Current Rank?",
        answer: "If in your last two ranked matches the average MMR is at least a couple divisions higher than your current rank you should consider your current MMR as \"current rank\" when making the purchase."
      },
      {
        question: "What If I Find After Purchase That My Current MMR And Rank Dont Match?",
        answer: "In that case, please message us in the live support chat and we will help you find a fast and viable solution."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost de victoire nette?",
        answer: "Une victoire nette est la différence entre le nombre de victoires et le nombre de défaites. Pour chaque défaite, vous recevez une victoire supplémentaire. ex : 2 victoires nettes = 2V-0D ou 3V-1D."
      },
      {
        question: "Que se passe-t-il si j\'atteins une nouvelle division et qu\'il me reste des victoires nettes?",
        answer: "Dans les rangs inférieurs à Diamant, nous jouons une division au-dessus du rang initial. En Diamant+, les victoires nettes ne sont valables que pour la division achetée."
      },
      {
        question: "Puis-je acheter des victoires nettes avant que mes placements ne soient terminés?",
        answer: "Seuls les comptes dont tous les placements ont été effectués sont éligibles pour les victoires nettes."
      },
      {
        question: "Puis-je jouer en duo avec le booster?",
        answer: "En effet, vous pouvez le faire. Pour ce faire, allez dans le menu de personnalisation de la commande et sélectionnez \"Duo\" avant de cliquer sur \"Acheter Boost maintenant\"."
      },
      {
        question: "Que se passe-t-il si mon MMR est plus élevé que mon rang actuel?",
        answer: "Si, lors de vos deux derniers matchs classés, le MMR moyen est supérieur de quelques divisions à votre rang actuel, vous devez considérer votre MMR actuel comme \"rang actuel\" au moment de l\'achat."
      },
      {
        question: "Que se passe-t-il si je constate, après l\'achat, que mon MMR actuel et mon rang ne correspondent pas?",
        answer: "Dans ce cas, veuillez nous envoyer un message dans le chat du support en direct et nous vous aiderons à trouver une solution rapide et viable."
      }
    ],
    de: [
      {
        question: "Was ist ein Net Win Boost?",
        answer: "Ein Net Win Boost ist die Differenz zwischen der Anzahl der Siege und der Anzahl der Niederlagen. Für jede Niederlage erhältst du einen zusätzlichen Sieg. z.B.: 2 Net Wins = 2W-0L oder 3W-1L."
      },
      {
        question: "Was ist, wenn ich einen neuen Rang erreiche und noch Net Wins übrig habe?",
        answer: "In Rängen unterhalb von Diamond spielen wir eine Division über dem ursprünglichen Rang. Bei Diamond+ gelten die Net Wins nur für die gekaufte Division."
      },
      {
        question: "Kann ich Net Wins kaufen, bevor meine Platzierungen abgeschlossen sind?",
        answer: "Nur Konten, bei denen alle Platzierungen abgeschlossen sind, sind für Net Wins berechtigt."
      },
      {
        question: "Kann ich mit dem Booster im Duo Queue Boosting spielen?",
        answer: "Ja, das kannst du. Gehe dazu in das Menü zur Bestellungsanpassung und wähle \"Duo\" aus, bevor du auf \"Boost Jetzt Kaufen\" klickst."
      },
      {
        question: "Was ist, wenn mein MMR höher ist als mein aktueller Rang?",
        answer: "Wenn die durchschnittliche MMR deiner letzten beiden Ranglistenspiele mindestens einige Divisionen über deiner aktuellen Ranglistenposition liegt, solltest du deine aktuelle MMR als aktuelle Ranglistenposition betrachten, wenn du einkaufst."
      },
      {
        question: "Was ist, wenn ich nach dem Kauf feststelle, dass mein aktueller MMR und mein Rang nicht übereinstimmen?",
        answer: "Schreib uns in diesem Fall eine Nachricht im Live Support Chat und wir werden dir bei der Suche nach einer schnellen und praktikablen Lösung behilflich sein."
      }
    ],
    pt: [
      {
        question: "O que é um Boost de Net Wins?",
        answer: "Um Boost de Net Wins é a diferença entre o número de vitórias e derrotas. Para cada derrota, tu recebes uma vitória adicional. Ex: 2 Net Wins = 2V-0D ou 3V-1D."
      },
      {
        question: "E se eu alcançar um novo rank e ainda tiver Net Wins restantes?",
        answer: "Nos ranks abaixo de Diamond, jogamos uma divisão acima do rank inicial. Em Diamond+, as Net Wins são válidas apenas para a divisão comprada."
      },
      {
        question: "Posso comprar Net Wins antes de terminar os meus placements?",
        answer: "Somente contas com todas os placements completos são elegíveis para Net Wins."
      },
      {
        question: "Posso Jogar com o Booster em Duo Queue?",
        answer: "Sim, podes. Para fazer isso, vai para o menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\"."
      },
      {
        question: "E se meu MMR for maior do que meu rank atual?",
        answer: "Se nas tuas duas últimas partidas ranked o MMR médio for pelo menos algumas divisões acima do teu rank atual, deves considerar o teu MMR atual como \"rank atual\" ao fazer a compra."
      },
      {
        question: "E se eu descobrir após a compra que meu MMR atual e meu rank não correspondem?",
        answer: "Nesse caso, por favor, envia-nos uma mensagem no chat de suporte ao vivo e ajudmos-te a encontrar uma solução rápida e viável."
      }
    ],
    es: [
      {
        question: "¿Qué es un \"Net Win Boost\"?",
        answer: "Un Boost de Net Win es la diferencia entre el número de victorias y derrotas. Por cada derrota, recibes una victoria adicional. ej: 2 Net Wins = 2W-0L o 3W-1L."
      },
      {
        question: "¿Qué pasa si alcanzo un nuevo rango y aún me quedan Net Wins?",
        answer: "En rangos inferiores a Diamond se juega una división por encima del rango inicial. En Diamond+, las net wins solo son válidas para la división adquirida."
      },
      {
        question: "¿Puedo comprar Net Wins antes de que se completen mis clasificaciones?",
        answer: "Sólo las cuentas con todas las clasificaciones completadas pueden optar a Net Wins."
      },
      {
        question: "¿Puedo jugar con el Booster en Duo Queue Boosting?",
        answer: "Efectivamente, puedes hacerlo. Para ello, ve al menú de personalización del pedido y selecciona \"Duo\" antes de hacer clic en \"Comprar Boost ahora\"."
      },
      {
        question: "¿Qué ocurre si mi RMM es superior a mi rango actual?",
        answer: "Si en tus dos últimas partidas clasificatorias la media de MMR es al menos un par de divisiones superior a tu rango actual, debes considerar tu MMR actual como \"rango actual\" a la hora de hacer la compra."
      },
      {
        question: "¿Qué pasa si después de la compra descubro que mi MMR actual y mi rango no coinciden?",
        answer: "En ese caso, envíanos un mensaje en el chat de asistencia en directo y te ayudaremos a encontrar una solución rápida y viable."
      }
    ]
  }

  private page = {
    title: {
      en: "Valorant Boosting - Net Wins Boosting for Valorant",
      fr: "Boosting Valorant - Boosting de victoire nette sur Valorant",
      de: "Valorant Boosting - Net Wins Boosting für Valorant",
      pt: "Boosting Valorant - Boost de Net Wins para Valorant",
      es: "Valorant Boosting - Boost de Net Wins para Valorant",
    },
    metaDescription: {
      en: "The Best Valorant Boost Service to win RR and increase your MMR quickly, easily, and affordably. Get started now and see the results for yourself!",
      fr: "Le meilleur service de boost Valorant pour gagner des RR et augmenter votre MMR rapidement, facilement et à un prix abordable. Commencez dès maintenant et voyez les résultats par vous-même!",
      de: "Der beste Valorant Boost Service, um schnell, einfach und günstig RR zu verdienen und deine MMR zu erhöhen. Beginne jetzt und überzeuge dich selbst von den Ergebnissen!",
      pt: "O melhor serviço de Boosting de Valorant para ganhar RR e aumentar seu MMR rapidamente, facilmente e a um preço acessível. Começa agora e vê os resultados por ti mesmo!",
      es: "El mejor servicio de Boost de Valorant para ganar RR y aumentar tu MMR de forma rápida, fácil y asequible. ¡Empieza ahora y comprueba los resultados por ti mismo!",
    }
  }


  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}